import React from 'react';
import Listado from '../oficios/Listado';
import {Paginador, BaseModal} from '../comun/Index';
import ModalPase from '../oficios/ModalPase';
import ModalPersonas from '../oficios/ModalPersonas';
import axios from 'axios';

const getOficios = function(params){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/oficios/todos/'
    const config = {
      headers:{authorization:sessionStorage.getItem('token')},
      params
    };
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  })
}

const getAreas = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/areas/todos/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.areas)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

const modeloPase = {
  oficio_id:null,
  areaSelec:null,
  estadoSelec:null,
  estado_id:2,
  observaciones:""
}

const modeloPersonas = {
  oficio_id:null,
  personasSelec:[]
}

const setPersonas = function(datos){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/oficios/todos/personas';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve()
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  })
}

/* 
post “/observado” (Agente)
post “/parcial” (Agente)
post “/finalizado” (Agente)
post “/derivado” (Todos)
*/

const getURLPase = function(estado_id){
  let recurso = ''
  switch (estado_id) {
    case 1:
      recurso = '/agente/observado';
      break;
    case 2:
      recurso = '/todos/derivado';
      break;
    case 3:
      recurso = '/agente/parcial';
      break;
    case 4:
      recurso = '/agente/finalizado';
      break;
    default:
      break;
  }
  return(recurso);
}

const setPase = function(datos){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/pases' + getURLPase(datos.estado_id);
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) => resolve(res.data))
    .catch((error) => reject(error));
  })
}

export default class Pendientes extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      loading:false,
      oficios:[],
      areas:[],
      total:0,
      limit:20,
      offset:0,
      datosPase:modeloPase,
      datosPersonas:modeloPersonas,
      showPase:false,
      showPersonas:false
    }
  }

  componentDidMount(){
    getAreas()
    .then((areas) =>{
      this.setState({areas});
      this.actualizar();
    })
    .catch((error) =>{
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  actualizar(offsetP = null){
    this.setState({loading:true});
    let {offset, limit} = this.state;
    const params = {
      propio:true,
      offset: offsetP === null ? offset : offsetP, 
      limit
    }
    getOficios(params)
    .then((resp) => {
      this.setState({oficios:resp.oficios, total:resp.total, loading:false});
    })
    .catch((error) => {
      console.log(error);
      this.setState({loading:false});
      alert("Ocurrió un error");
    })
  }

  setOffset(offset){
    if (!this.state.loading){
      this.setState({offset});
      this.actualizar(offset);
    }
  }

  editar(formulario, campo, valor){
    let datosFormulario = JSON.parse(JSON.stringify(this.state[formulario]));
    datosFormulario[campo] = valor;
    this.setState({[formulario]:datosFormulario});
  }

  realizarPase(oficio_id){
    let datosPase = JSON.parse(JSON.stringify(this.state.datosPase));
    datosPase.oficio_id = oficio_id;
    this.setState({datosPase, showPase:true})
  }

  agregarPersonas(oficio_id){
    let datosPersonas = JSON.parse(JSON.stringify(this.state.datosPersonas));
    datosPersonas.oficio_id = oficio_id;
    this.setState({datosPersonas, showPersonas:true})
  }

  guardarPase(datosPase){
    let datos = {
      area_id: datosPase.areaSelec.id,
      oficio_id: datosPase.oficio_id,
      estado_id:datosPase.estado_id
    }
    if (datosPase.estadoSelec !== null) datos.estado_id = datosPase.estadoSelec.id;
    setPase(datos)
    .then(() => {
      this.actualizar()
      this.setState({datosPase:modeloPase, showPase:false});
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  guardarPersonas(datosPersonas){
    datosPersonas.personas = datosPersonas.personasSelec.map((persona) => persona.id)
    delete datosPersonas.personasSelec;
    setPersonas(datosPersonas)
    .then(() => {
      alert("Personas guardadas");
      this.setState({datosPersonas:modeloPersonas, showPersonas:false});
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  render(){
    const {
      loading, oficios,
      total,limit,offset,
      datosPase,showPase,
      datosPersonas, showPersonas,
      areas
    } = this.state;
    return(
      <div className="TramitesTodo">
        {showPase && 
          <ModalPase
            nuevo={true}
            areas={areas}
            datosPase={datosPase}
            editar={(campo, valor) => this.editar('datosPase', campo, valor)}
            guardar={() => this.guardarPase(datosPase)}
            salir={() => this.setState({datosPase:modeloPase, showPase:false})}
          />
        }
        {showPersonas && 
          <ModalPersonas
            datosPersonas={datosPersonas}
            editar={(campo, valor) => this.editar('datosPersonas', campo, valor)}
            guardar={() => this.guardarPersonas(datosPersonas)}
            salir={() => this.setState({datosPersonas:modeloPersonas, showPersonas:false})}
          />
        }
        <h3>Pendientes</h3>
          {loading && 
            <h3>Cargando...</h3>
          }
          {(!loading && oficios?.length > 0) &&
            <Listado
              oficios={oficios}
              mesa={true}
              realizarPase={(oficio_id) => this.realizarPase(oficio_id)}
              agregarPersonas={(oficio_id) => this.agregarPersonas(oficio_id)}
              establecerRecordatorio={(oficio_id)=>alert("Establece rec.")}
              subir={(oficio_id) => alert("Subir archivo")}
              descargar={(oficio_id) => alert("Descargar archivo")}
            />
          }
          {oficios?.length > 0 &&
            <Paginador
              total={total}
              limit={limit}
              offset={offset}
              setOffset={(offset) => {window.scrollTo(0,0);this.setOffset(offset)}}
            />
          }
      </div>
    )
  }
}